export const SENTRY_IGNORED_ERRORS = [
  /**
   * "InvalidStateError: Transition was aborted" is thrown by the browser's View
   * Transitions API when the tab is backgrounded during a react-router
   * viewTransition navigation. The navigation still completes — only the
   * cross-fade animation is skipped — so this is harmless noise, not a real
   * error.
   */
  "InvalidStateError: Transition was aborted",
];
